module.exports = __webpack_public_path__ + "media/images/two-6445963c.svg";